import service from './request'

export function register(param) {
    return service.post('/users/register', param)
}

export function authLogin(param) {
    return service.post('/users/login', param)
}

export function authLogout(param) {
    return service.post('/users/logout', param)
}

export function getUserInfo() {
    return service.get('/users/info')
}

export function getUserList(param) {
    return service.get('/users', param)
}

export function getUserDetail(id) {
    return service.get('/users/' + id)
}

export function saveUser(param) {
    return service.post('/users', param)
}

export function updateUser(id, param) {
    return service.put('/users/' + id, param)
}

export function deleteUser(id) {
    return service.delete('/users/' + id)
}

export function sendSmsCode(param) {
    return service.post('/smsCodes', param)
}

export function getUserLogList(param) {
    return service.get('/userLogs', param)
}

export function getApiLogList(param) {
    return service.get('/apiLogs', param)
}

export function getAdapayRequestList(param) {
    return service.get('/adapayRequests', param)
}

export function getAdapayCallbackList(param) {
    return service.get('/adapayCallbacks', param)
}

export function getDougongRequestList(param) {
    return service.get('/donggongRequests', param)
}

export function getDougongCallbackList(param) {
    return service.get('/donggongCallbacks', param)
}